module.exports = __webpack_public_path__ + "static/img/Treasure.e659b786.png";